import React from 'react'
export const AppUpdateDialog = ({ showButton = false }: { showButton?: boolean }) => <></>
